var _a, _b, _c, _d, _e, _f;
import { categoryMap } from 'hx-util';
import { createDinTestStore, defaultInitialDinTestState, } from 'hx-din-test';
import { createSimpleStore } from 'hx-simple-store';
import { configureStoreWithRouter, createWidgetStore, } from 'hx-widget-store';
import { createWizardStore } from 'hx-wizard';
export var WIDGET_FEATURE_KEY = (_a = createWidgetStore(), _a.WIDGET_FEATURE_KEY), widgetStoreReducer = _a.widgetStoreReducer, widgetActions = _a.widgetActions, messageListenerMiddleware = _a.messageListenerMiddleware;
export var WIZARD_FEATURE_KEY = (_b = createWizardStore(), _b.WIZARD_FEATURE_KEY), wizardStoreReducer = _b.wizardStoreReducer, wizardActions = _b.wizardActions;
export var speakToAnExpertFormReducer = (_c = createSimpleStore('speakToAnExpertForm'), _c.speakToAnExpertFormReducer), updateSpeakToAnExpertForm = _c.updateSpeakToAnExpertForm;
export var DIN_TEST_FEATURE_KEY = (_d = createDinTestStore(defaultInitialDinTestState, {
    // Categorizes SNR by finding the first cutoff greater than the measured value.
    // (e.g., -18 matches 'normal' because -17.1 > -18).
    cutOffs: [
        { snr: -17.1, category: categoryMap.normal },
        { snr: -12.5, category: categoryMap.mild },
        { snr: Infinity, category: categoryMap.severe },
    ],
}), _d.DIN_TEST_FEATURE_KEY), dinTestStoreReducer = _d.dinTestStoreReducer, dinTestActions = _d.dinTestActions, selectActiveTestStep = _d.selectActiveTestStep;
export var store = (_f = configureStoreWithRouter({
    reducers: (_e = {},
        _e[WIDGET_FEATURE_KEY] = widgetStoreReducer,
        _e[WIZARD_FEATURE_KEY] = wizardStoreReducer,
        _e[DIN_TEST_FEATURE_KEY] = dinTestStoreReducer,
        _e.speakToAnExpertForm = speakToAnExpertFormReducer,
        _e),
    middleware: [messageListenerMiddleware],
}), _f.store), history = _f.history;
